import React, { memo } from 'react';
import Tagline from './Tagline';
import Services from './Services';
import VideoSection from './VideoSection';
import ThreeDmodel from './ThreeDmodel';

const Home = () => {
  return (
    <>
      <Tagline />
      {/* <ThreeDmodel /> */}
      <Services />
      <VideoSection />
    </>
  )
}

export default memo(Home);
